import apiClient from './apiClient';

export const initializePayment = async (payload) => {
  const { data } = await apiClient.post('/api/stripe/initialize-payment', payload);
  return data;
};

export const initializeSubscription = async (payload) => {
  const { data } = await apiClient.post('/api/stripe/initialize-subscription', payload);
  return data;
};
